export enum CarrierNumberFormat {
  National = 0,
  E164 = 1,
  InternationalWithoutPlus = 2,
}
